<template>
  <div class="rounded-lg bg-white relative flex flex-col">
    <header v-if="withHeader" class="mb-2 p-6 rounded-t-lg" :class="`bg-${headerColour} text-${textColour}`">
      <slot name="header"></slot>
    </header>

    <div class="flex flex-col w-full h-full p-6 pt-0">
      <slot></slot>
    </div>

    <!-- <slot></slot> -->
  </div>
</template>

<script>
export default {
  name: 'panel',

  props: {
    withHeader: Boolean,
    headerColour: {
      type: String,
      default: 'transparent'
    },
    textColour: {
      type: String,
      default: 'black'
    }
  }
}
</script>
